import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Spinner from "react-bootstrap/Spinner";
import Top from "../components/Top";
import { API_BASE_URL } from "../api/config";
import "../index.css";

function Team() {
  const { isLoading, isError, data, error } = useQuery({
    queryKey: ["team-members"],
    queryFn: async () => {
      const res = await fetch(
        `${API_BASE_URL}/api/user/team_members?limit=50`
      );
      return await res.json();
    },
  });

  if (isLoading) {
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <Spinner
          animation="border"
          role="status"
          style={{ height: "89px", width: "89px" }}
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <p className="mt-3">Kindly be patient while we fetch your data</p>
      </div>
    );
  }

  if (isError) {
    return <p>An Error Occurred: {error.message}</p>;
  }

  const members = data?.data ?? [];

  return (
    <div className="team-page">
      <div className="container team-content">
        <div className="team-header">
          <h6>Meet The Team</h6>
          <h3>Our Team</h3>
          <p className="team-subtitle">
            Get to know the people behind AAER
          </p>
        </div>
        <div className="row">
          {members.map((member) => (
            <div className="col-12 col-sm-6 col-lg-4 mb-4" key={member.id}>
              <Link
                to={`/team/${member.id}`}
                className="text-decoration-none"
                style={{ color: "var(--text-color)" }}
              >
                <div className="team-card">
                  <div className="team-card-img-wrapper">
                    <img
                      src={
                        member.profile_image
                          ? `${API_BASE_URL}/${member.profile_image}`
                          : "https://via.placeholder.com/300x300?text=No+Photo"
                      }
                      alt={`${member.first_name} ${member.last_name}`}
                      className="team-card-img"
                    />
                  </div>
                  <div className="team-card-body">
                    {member.title && (
                      <small className="team-card-title-prefix">
                        {member.title}
                      </small>
                    )}
                    <h5 className="team-card-name">
                      {member.first_name} {member.last_name}
                    </h5>
                    <p className="team-card-position">{member.position}</p>
                    {member.summary && (
                      <p className="team-card-summary">
                        {member.summary.length > 120
                          ? member.summary.substring(0, 120) + "..."
                          : member.summary}
                      </p>
                    )}
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
        {members.length === 0 && (
          <p className="text-center mt-5">No team members found.</p>
        )}
      </div>
      <Top />
    </div>
  );
}

export default Team;
